module.exports = __webpack_public_path__ + "img/mikeking.99545fb0.jpg";